(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/draws/assets/javascripts/internal/fetch-draws.js') >= 0) return;  svs.modules.push('/components/numbergames/draws/assets/javascripts/internal/fetch-draws.js');

'use strict';

let productMapping;
let DRAW_STATES;
let PRODUCT_JUPITER_VERSION_MAPPING;
let PRODUCT_TO_PRODUCT_DRAW_ID_MAPPING;
let drawgamesApiCaller;

function isValidNumber(number) {
  return Number.isFinite(Number(number)) && !isNaN(parseInt(number, 10));
}

function fetchCurrentDrawsWrapper(req) {
  return async productDrawIds => {
    if (!productDrawIds || !productDrawIds.length) {
      throw new Error('No productDrawIds provided to fetchCurrentDraws');
    }
    let response;
    let uniqueProducts;
    try {
      if (!Array.isArray(productDrawIds)) productDrawIds = [productDrawIds];
      uniqueProducts = Array.from(new Set(productDrawIds.map(productDrawId => PRODUCT_TO_PRODUCT_DRAW_ID_MAPPING[productDrawId])));
      response = await Promise.all(uniqueProducts.map(product => {
        const jupiterVersion = PRODUCT_JUPITER_VERSION_MAPPING[product];
        return drawgamesApiCaller.getDrawProductDraws({
          req,
          product: productMapping.getMigrationProductDrawId(product, {
            apiCaller: drawgamesApiCaller,
            apiPathFnName: 'getDrawProductDraws'
          }),
          jupiterVersion
        });
      }));
    } catch (error) {
      throw new Error("fetchCurrentDraws: Failed to fetch current draws for ".concat(uniqueProducts, "  ").concat(error));
    }
    const currentDraws = [];
    const drawsToFetch = [];
    const closedDraws = [];
    try {
      let responses;
      if (svs.isServer) {
        responses = Array.isArray(response) ? response : [response];
      } else {
        responses = (Array.isArray(response) ? response : [response]).map(item => {
          var _item$response;
          return (_item$response = item === null || item === void 0 ? void 0 : item.response) !== null && _item$response !== void 0 ? _item$response : item;
        }).flat().filter(Boolean);
      }
      responses.map(_ref => {
        let draw = _ref.draw,
          draws = _ref.draws;
        return draw || draws;
      }).forEach(draw => {
        const current = draw.currentDraws || [draw.currentDraw];
        const future = Array.isArray(draw.futureDraws) ? draw.futureDraws : [draw.futureDraws];
        future.forEach(futureDraw => {
          const productId = futureDraw.productId;
          const productDrawId = productMapping.getProductDrawId(productId);
          const currentDraw = current.find(draw => (draw === null || draw === void 0 ? void 0 : draw.productId) === productId);
          if (currentDraw) {
            currentDraws.push(currentDraw);
            closedDraws.push({
              productId,
              drawNumber: currentDraw.drawNumber - 1,
              drawStateId: DRAW_STATES.CLOSED
            });
          } else {
            drawsToFetch.push({
              productDrawId,
              drawNumber: futureDraw.nextDrawNumber
            });
            drawsToFetch.push({
              productDrawId,
              drawNumber: futureDraw.nextDrawNumber - 1
            });
          }
        });
      });
    } catch (error) {
      throw new Error("fetchCurrentDraws: Failed to parse response from ".concat(uniqueProducts, " ").concat(error));
    }
    return {
      currentDraws,
      drawsToFetch,
      closedDraws
    };
  };
}

function fetchDrawsByDrawIdWrapper(req) {
  return async drawIds => {
    if (!Array.isArray(drawIds)) drawIds = [drawIds];
    const allProductDrawIds = productMapping.getAllDrawIds();
    const drawsToFetch = drawIds.filter(drawId => drawId && allProductDrawIds.includes(drawId.productDrawId) && isValidNumber(drawId.drawNumber));
    if (!drawsToFetch.length) {
      throw new Error('No valid drawIds provided to fetchDrawsByDrawId');
    }
    let response;
    try {
      response = await Promise.all(drawsToFetch.map(draw => drawgamesApiCaller.getDrawProductDrawsByDrawNumber({
        req,
        product: draw.productDrawId,
        drawNumber: draw.drawNumber
      })));
    } catch (error) {
      throw new Error("fetchDrawsByDrawId: Failed to fetch draws for ".concat(drawsToFetch, " ").concat(error));
    }
    const draws = [];
    const closedDraws = [];
    try {
      let responses;
      if (svs.isServer) {
        responses = Array.isArray(response) ? response : [response];
      } else {
        responses = (Array.isArray(response) ? response : [response]).map(item => {
          var _item$response2;
          return (_item$response2 = item === null || item === void 0 ? void 0 : item.response) !== null && _item$response2 !== void 0 ? _item$response2 : item;
        }).flat().filter(Boolean);
      }
      responses.forEach(_ref2 => {
        let draw = _ref2.draw;
        if (draw.drawStateId > DRAW_STATES.OPEN) {
          closedDraws.push(draw);
        } else {
          draws.push(draw);
        }
      });
    } catch (error) {
      throw new Error("fetchDrawsByDrawId: Failed to parse response from ".concat(drawsToFetch, " ").concat(error));
    }
    return {
      draws,
      closedDraws
    };
  };
}
if (svs.isServer) {
  const trinidadCore = require('@svenskaspelab/trinidad-core').core;
  var _trinidadCore$compone = trinidadCore.components.require('numbergames', 'product-mapping');
  productMapping = _trinidadCore$compone.productMapping;
  var _require = require('../constants.es6');
  DRAW_STATES = _require.DRAW_STATES;
  PRODUCT_JUPITER_VERSION_MAPPING = _require.PRODUCT_JUPITER_VERSION_MAPPING;
  PRODUCT_TO_PRODUCT_DRAW_ID_MAPPING = _require.PRODUCT_TO_PRODUCT_DRAW_ID_MAPPING;
  drawgamesApiCaller = trinidadCore.components.require('tur', 'api-caller').drawgamesApiCaller;
  module.exports = {
    fetchCurrentDraws: req => fetchCurrentDrawsWrapper(req),
    fetchDrawsByDrawId: req => fetchDrawsByDrawIdWrapper(req)
  };
} else {
  productMapping = svs.numbergames.productMapping;
  drawgamesApiCaller = svs.tur.apiCaller.drawgames;
  var _svs$numbergames$draw = svs.numbergames.draws.constants;
  DRAW_STATES = _svs$numbergames$draw.DRAW_STATES;
  PRODUCT_JUPITER_VERSION_MAPPING = _svs$numbergames$draw.PRODUCT_JUPITER_VERSION_MAPPING;
  PRODUCT_TO_PRODUCT_DRAW_ID_MAPPING = _svs$numbergames$draw.PRODUCT_TO_PRODUCT_DRAW_ID_MAPPING;
  Object.assign(svs.numbergames.draws.internal, {
    fetchCurrentDraws: fetchCurrentDrawsWrapper(),
    fetchDrawsByDrawId: fetchDrawsByDrawIdWrapper()
  });
}

 })(window);